import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import React from 'react';
import { hot } from 'react-hot-loader';

export default hot(module)(function index({ onClick = () => {}, changeIcon = false }) {
	return (
		<span className="show-password" onClick={onClick}>
			{changeIcon ? <EyeOutlined /> : <EyeInvisibleOutlined />}
		</span>
	);
});
